import styled from 'styled-components';

import NavLinkExternal from 'components/app-header/nav-link-external';
import UniversalLink from 'components/universal-link';

export const Container = styled.div<{ backgroundImage: string }>`
  color: ${Styles.color.white};
  margin: 0;
  background-color: ${Styles.color.contrastBackground};
  background-image: ${p => `url(${p.backgroundImage})`};
  background-position: center;
  background-size: contain;
  background-repeat: repeat-x;
  display: flex;
  flex-direction: column;
`;

export const MeterContainer = styled.div``;

export const CircleProgressContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const PointsContainer = styled.div<{ containerHeight: number }>`
  font-family: ${Styles.fontFamily.brand};
  text-align: center;
  height: ${props => props.containerHeight}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PointsText = styled.div`
  font-family: ${Styles.fontFamily.brand};
  font-size: 3rem;

  ${Styles.desktop`
    font-size: 5.125rem;
  `}
`;

export const PointsLabel = styled.h2`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.125rem;
  margin: 0;

  ${Styles.desktop`
    font-size: 1.75rem;
  `}
`;

export const RewardTextContainer = styled.div`
  margin-top: -20px;
  text-align: center;

  ${Styles.desktop`
    margin-top: -80px;
  `}
`;

export const RewardTitle = styled.h2`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1rem;
  margin: 0;

  ${Styles.desktop`
    font-size: 1.125rem;
  `}
`;

export const RewardDetails = styled.div`
  font-size: 0.8125rem;

  ${Styles.desktop`
    font-size: 1rem;
  `}
`;

export const PointsTextContainer = styled.div``;

export const MeterIconWrapper = styled.div`
  display: none;
`;

export const MeterIconInnerWrapper = styled.div`
  display: none;
`;

export const PointMeterCtaButton = styled(UniversalLink)`
  margin: 1rem auto;
  z-index: ${Styles.zIndex.normal};
`;

export const ExternalLinkStyled = styled(NavLinkExternal)`
  color: ${Styles.color.primary};
  background-color: ${Styles.color.white};
  padding: 0.75rem 3rem;
  border-radius: 9999rem;

  &:first-of-type {
    margin-left: auto;
  }
`;
